import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DealerRoutingModule } from './dealer.routing';
import { DealerComponent } from './dealer.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { DealerEditDialogComponent } from './dealer-edit/dealer-edit.component';
import { DealerAccountComponent } from './dealer-account/dealer-account.component';
import { DealerPublicComponent } from './dealer-public/dealer-public.component';
import { DealerAppointmentsComponent } from './dealer-appointments/dealer-appointments.component';
import { JobSearchComponent } from './job-search/job-search.component';
import { DealerMyProvidersComponent } from './dealer-myproviders/dealer-myproviders.component';
import { DealerContractsComponent } from './dealer-contracts/dealer-contracts.component';
import { DealerMyOwnersComponent } from './dealer-myowners/dealer-myowners.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { GoogleMapsModule } from '@angular/google-maps';
import { DealerConversationsComponent } from './dealer-conversations/dealer-conversations.component';
import { DealerAlertsComponent } from './dealer-alerts/dealer-alerts.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { JobsComponent } from 'src/app/public/keep/elements/jobs/jobs.component';
import { JobSearchCriteriaComponent } from 'src/app/public/keep/elements/job-search-criteria/job-search-criteria.component';
import { CarCardListComponent } from 'src/app/public/car/elements/car-card-list/car-card-list.component';
import { DealersComponent } from 'src/app/public/account/elements/dealers/dealers.component';
import { ConversationsComponent } from 'src/app/public/common/elements/conversations/conversations.component';
import { ContractsComponent } from 'src/app/public/account/elements/contracts/contracts.component';
import { AppointmentsComponent } from 'src/app/public/common/elements/appointments/appointments.component';
import { AlertsComponent } from 'src/app/public/common/elements/alerts/alerts.component';
import { KeepOffersComponent } from 'src/app/public/keep/elements/keep-offers/keep-offers.component';


@NgModule({
  declarations: [
    DealerComponent,
    
    DealerAccountComponent,
    DealerPublicComponent,
    
    DealerEditDialogComponent,

    DealerAppointmentsComponent,
    DealerConversationsComponent,
    DealerMyProvidersComponent,
    DealerMyOwnersComponent,
    DealerContractsComponent,
    DealerAlertsComponent,

    JobSearchComponent
  ],
  imports: [
    CommonModule,
    DealerRoutingModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    
    MatCardModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatExpansionModule,
    MatListModule,
    MatProgressBarModule,

    OverlayModule,

    GoogleMapsModule,

    MatDatepickerModule,
    MatNativeDateModule,

    JobsComponent,
    JobSearchCriteriaComponent,
    CarCardListComponent,
    DealersComponent,
    ConversationsComponent,
    ContractsComponent,
    AppointmentsComponent,
    AlertsComponent,
    KeepOffersComponent
  ],

  exports: [
    JobSearchComponent
  ]

})
export class DealerModule { }
